module.exports = __webpack_public_path__ + "img/well1.c959a88b.png";